import { ErrorCode, ErrorName } from 'src/constants';

import { ClientServicesLink } from '../ClientServicesLink/ClientServicesLink';

export interface UnknownErrorMessageProps {
  code?: ErrorCode; // TODO: remove code from error response
  name?: string; // TODO: replace name with ErrorName
  message?: string | string[];
}

export const UnknownErrorMessage = ({ code, name, message }: UnknownErrorMessageProps) => {
  if (name === ErrorName.Network && message) {
    return <p>{message}</p>;
  }

  if (code) {
    return (
      <p>
        Unknown error occurred (error code: {code}). Please try again later or contact <ClientServicesLink /> to
        resolve.
      </p>
    );
  }

  if (message) {
    return (
      <p>
        Unknown error occurred (error: {Array.isArray(message) ? message.join('; ') : message}). Please try again later
        or contact <ClientServicesLink /> to resolve.
      </p>
    );
  }

  return (
    <p>
      Unknown error occurred. Please try again later or contact <ClientServicesLink /> to resolve.
    </p>
  );
};
